import React from 'react';
import { Paper } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import useStyles from './DecisionItem.styles';

const DecisionItemSkeleton = () => {
  const classes = useStyles();

  return (
    <Paper className={classes.skeletonContainer}>
      <Skeleton className={classes.skeleton} />
      <Skeleton className={classes.skeleton} />
      <Skeleton className={classes.skeleton} />
      <Skeleton className={classes.skeletonMini} />
      <Skeleton className={classes.skeleton} />
      <Skeleton className={classes.skeletonMini} />
    </Paper>
  );
};

export default DecisionItemSkeleton;
